document.addEventListener('DOMContentLoaded',function(){
  var desktop=window.matchMedia('(min-width: 1150px)');
  function init(menu){
    var root=menu.querySelector('.custom-megamenu__root');
    var items=[].slice.call(menu.querySelectorAll('.custom-megamenu__root-item'));
    var panels=[].slice.call(menu.querySelectorAll('.custom-megamenu__panel'));
    var promos=[].slice.call(menu.querySelectorAll('.custom-megamenu__promo-set'));
    function activate(index){
      items.forEach(function(el,i){el.setAttribute('aria-selected',String(i===index));});
      panels.forEach(function(el,i){if(i===index){el.setAttribute('data-active','true');}else{el.removeAttribute('data-active');}});
      promos.forEach(function(el,i){if(i===index){el.setAttribute('data-active','true');}else{el.removeAttribute('data-active');}});
      var activePromo=promos[index];
      if(activePromo){
        [].forEach.call(activePromo.querySelectorAll('img'),function(img){if(img.loading==='lazy'){img.loading='eager';}});
      }
    }
    items.forEach(function(el){
      el.addEventListener('mouseenter',function(){if(!desktop.matches)return;activate(parseInt(el.getAttribute('data-mega-root-index')));});
      el.addEventListener('focus',function(){if(!desktop.matches)return;activate(parseInt(el.getAttribute('data-mega-root-index')));},true);
      el.addEventListener('click',function(){if(!desktop.matches)return;activate(parseInt(el.getAttribute('data-mega-root-index')));});
    });
    root.addEventListener('keydown',function(e){
      var current=items.findIndex(function(it){return it.getAttribute('aria-selected')==='true';});
      if(e.key==='ArrowDown'){e.preventDefault();var n=(current+1)%items.length;items[n].focus();activate(n);} 
      else if(e.key==='ArrowUp'){e.preventDefault();var p=(current-1+items.length)%items.length;items[p].focus();activate(p);} 
      else if(e.key==='Home'){e.preventDefault();items[0].focus();activate(0);} 
      else if(e.key==='End'){e.preventDefault();items[items.length-1].focus();activate(items.length-1);} 
      else if(e.key==='Enter' || e.key===' '){e.preventDefault();activate(current>=0?current:0);} 
      else if(e.key==='Escape'){var details=menu.closest('details');if(details)details.open=false;} 
    });
    var close=menu.querySelector('[data-action="close-megamenu"]');
    if(close){close.addEventListener('click',function(){var details=menu.closest('details');if(details)details.open=false;});}
  }
  [].forEach.call(document.querySelectorAll('.custom-megamenu'),function(menu){init(menu);});
});
